import { Modal as MantineModal } from '@mantine/core';

export const Modal = MantineModal.extend({
	defaultProps: {
		centered: true,
		overlayProps: {
			transitionProps: {
				duration: 150,
			},
		},
		transitionProps: {
			duration: 150,
		},
		closeButtonProps: {
			id: 'modal-close-button',
		},
	},
});

export const ModalRoot = MantineModal.Root.extend({
	defaultProps: {
		centered: true,
		transitionProps: {
			duration: 150,
		},
	},
});

export const ModalOverlay = MantineModal.Overlay.extend({
	defaultProps: {
		transitionProps: {
			duration: 150,
		},
	},
});
